export default __webpack_public_path__ + "static/media/popupCardone.fcd1c96f.png";